<template>
  <NavbarComponent @updatePageIndex="updatePageIndex" :activePage="activePage" v-if="!$route.meta.hideNavbar"></NavbarComponent>
  <router-view @updatePageIndex="updatePageIndex"></router-view>
</template>

<script>
import NavbarComponent from './components/NavbarComponent.vue';

export default {
  name: 'App',
  components: {
    NavbarComponent
  },
  data() {
    return {
      activePage: -1
    };
  },
  methods: {
    updatePageIndex(newIndex) {
      this.activePage = newIndex;
    }
  }
}
</script>

<style lang="scss">
  @import '~bootstrap/scss/bootstrap';  

html, body {
  min-height: 100vh;
  height: 100%;
  // overflow: auto;
}

</style>
